import React from 'react'
import {
  FAILED,
  NOT_WATERMARKED,
  PROCESSING,
  WATERMARK_REMOVED,
  WATERMARKED,
} from '@disco/constants/WatermarkStatusesTypes'
import ContactUsLink from 'components/ui/contact-us-link'
import type { LozengeColor } from 'components/ui/lozenge'
const trackOptions: {
  failed: () => {
    color: LozengeColor
    text: string
    tooltip: React.ReactNode
  }
  not_watermarked: () => {
    color: LozengeColor
    icon: string
    text: string
    tooltip: React.ReactNode
  }
  processing: () => {
    color: LozengeColor
    text: string
    tooltip: string
  }
  watermark_removed: () => {
    color: LozengeColor
    strikethrough: boolean
    text: string
    tooltip: string
  }
  watermarked: () => {
    color: LozengeColor
    text: string
  }
} = {
  [WATERMARKED]() {
    return {
      color: 'blue',
      text: 'Watermarked',
    }
  },

  [WATERMARK_REMOVED]() {
    return {
      color: 'yellow',
      strikethrough: true,
      // TODO: Short form should be defined with component prop, then playlist and track options can be merged
      text: 'W',
      tooltip:
        'This track was watermarked previously but is currently not watermarked in any playlists.',
    }
  },

  [NOT_WATERMARKED]() {
    return {
      color: 'yellow',
      icon: 'warning',
      text: 'Not watermarked',
      tooltip: (
        <>
          This track is not watermarked in this playlist.
          <a className="WatermarkingStatusFlag_Link" href="#">
            Find out more
          </a>
        </>
      ),
    }
  },

  [FAILED]() {
    return {
      color: 'bold-red',
      text: 'Failed',
      tooltip: (
        <>
          Watermarking for this track failed. Please{' '}
          {
            <ContactUsLink intercomMsg="I’m having issues with watermarking failing on a track">
              contact us
            </ContactUsLink>
          }{' '}
          for assistance
        </>
      ),
    }
  },

  [PROCESSING]() {
    return {
      color: 'bold-green',
      text: 'Processing',
      tooltip: 'Watermarking for this track is still in progress.',
    }
  },
}
export default trackOptions
